import { render, staticRenderFns } from "./VDesigningTableTools.vue?vue&type=template&id=1bce5d00&"
import script from "./VDesigningTableTools.vue?vue&type=script&lang=ts&"
export * from "./VDesigningTableTools.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningTableTools.vue?vue&type=style&index=0&id=1bce5d00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports